import { GameState } from '../Game/gameSlice';
import { EncryptStorage } from 'encrypt-storage';
import { msToTime } from './js-helpers';
import { DefaultEnums } from '../Enums/GameEnums';


const LOCAL_STORAGE_KEY = 'byRVxESNBf7A&w-bob';
const LOCAL_STORAGE_SECRET = 'we-should-not-put-it-here-but-what-the-hell-pls-dont-hack-us-bob';

const encryptStorage = new EncryptStorage(LOCAL_STORAGE_SECRET);

export const getLocalStorage = () => {
    return encryptStorage.getItem(LOCAL_STORAGE_KEY) as GameState;
}

export const setLocalStorage = (data: GameState) => {

    if (!data) {
        return;
    }

    if (!data.hasGameStarted) {
        return;
    }

    if (data.startTime) {
        const timeDifference = new Date().getTime() - new Date(data.startTime).getTime();
        data.timePlayed = data.timePlayed + (timeDifference < DefaultEnums.DEFAULT_TIMETRACKING_TIMEOUT ? timeDifference : DefaultEnums.DEFAULT_TIMETRACKING_TIMEOUT);
        data.startTime = new Date();
    }

    console.log(msToTime(data.timePlayed));

    return encryptStorage.setItem(LOCAL_STORAGE_KEY, Object.assign({}, data));
}